export const EXPO_MATCHING_DIRECTIONS = {
    TO_EMPLOYEE: { value: "TO_EMPLOYEE", text: "개인회원" },
    TO_EMPLOYER: { value: "TO_EMPLOYER", text: "기업회원" },
};
